export const PREMIUM_LIST_PATH = '/products/list'
export const OUTLET_LIST_PATH = '/products/outlet/list'

const isOnCatalogPath = (pathname, basePath) =>
  pathname === basePath || (basePath && pathname.startsWith(`${basePath}/`))

const getBrandIdFromPath = (pathname, basePath) => {
  if (!isOnCatalogPath(pathname, basePath)) {
    return ''
  }

  if (pathname === basePath) {
    return ''
  }

  return pathname.slice(basePath.length + 1).split('/')[0]
}

export const getXlsFeedVariant = (pathname) => {
  if (isOnCatalogPath(pathname, OUTLET_LIST_PATH)) {
    return 'outlet'
  }

  if (isOnCatalogPath(pathname, PREMIUM_LIST_PATH)) {
    return 'premium'
  }

  return null
}

export const getProductsSyncContext = (location, { uid } = {}) => {
  const pathname = location?.pathname || ''

  return {
    premiumBrandId: getBrandIdFromPath(pathname, PREMIUM_LIST_PATH),
    outletBrandId: getBrandIdFromPath(pathname, OUTLET_LIST_PATH),
    xlsFeedVariant: getXlsFeedVariant(pathname),
    uid: uid || null,
  }
}

export const PRODUCTS_SYNC_DEFINITIONS = [
  {
    id: 'brands',
    label: 'Бренди',
    name: 'syncBrands',
    getDateKey: () => 'brands',
    getPayload: () => null,
    syncAllBrands: false,
    isDisabled: () => false,
  },
  {
    id: 'premium',
    label: 'Premium каталог',
    name: 'syncProducts',
    getDateKey: (ctx) => ctx.premiumBrandId,
    getPayload: (ctx) => (ctx.premiumBrandId ? { brandId: ctx.premiumBrandId } : null),
    syncAllBrands: false,
    isDisabled: (ctx) => !ctx.premiumBrandId,
    disabledTitle: 'Оберіть бренд у Premium каталозі',
  },
  {
    id: 'outlet',
    label: 'Outlet каталог',
    name: 'syncOutletProducts',
    getDateKey: () => 'outletCatalog',
    getPayload: () => null,
    syncAllBrands: false,
    isDisabled: () => false,
  },
  {
    id: 'remains',
    label: 'Залишки',
    name: 'syncRemains',
    getDateKey: () => 'remains',
    getPayload: () => null,
    syncAllBrands: false,
    isDisabled: () => false,
  },
  {
    id: 'xlsFeed',
    label: 'XLS Feed',
    isFeedAction: true,
    isDisabled: (ctx) => !ctx.xlsFeedVariant,
    disabledTitle: 'Відкрийте Premium або Outlet каталог',
  },
  {
    id: 'siteSearch',
    label: 'Оновити пошук',
    name: 'rebuildSiteSearchIndex',
    getDateKey: () => 'siteSearchIndex',
    getPayload: () => null,
    syncAllBrands: false,
    isDisabled: (ctx) => !ctx.canUpdateSiteSearch,
    disabledTitle: 'Немає доступу до оновлення пошуку',
  },
]

export const resolveSyncItems = (context) =>
  PRODUCTS_SYNC_DEFINITIONS.map((definition) => {
    if (definition.isFeedAction) {
      const disabled = definition.isDisabled(context)

      return {
        id: definition.id,
        label: definition.label,
        isFeedAction: true,
        feedVariant: context.xlsFeedVariant,
        brandId: context.xlsFeedVariant === 'outlet' ? context.outletBrandId : context.premiumBrandId,
        disabled,
        disabledTitle: definition.disabledTitle,
        isPlaceholder: false,
      }
    }

    const disabled = definition.isDisabled(context)

    return {
      id: definition.id,
      label: definition.label,
      name: definition.name,
      dateKey: definition.getDateKey(context),
      payload: definition.getPayload(context),
      syncAllBrands: definition.syncAllBrands ?? false,
      disabled,
      disabledTitle: definition.disabledTitle,
      isPlaceholder: false,
    }
  })
